module.exports = __webpack_public_path__ + "img/data-pelanggaran-active.08efe254.svg";